import { useEffect, useRef } from "react";

export default function useAutoRefresh(refresh, deps = [], options = {}) {
  const refreshRef = useRef(refresh);
  const {
    enabled = true,
    intervalMs = 0,
    refreshOnFocus = true,
  } = options;

  useEffect(() => {
    refreshRef.current = refresh;
  }, [refresh]);

  useEffect(() => {
    if (!enabled) return undefined;

    const run = () => {
      if (document.visibilityState === "hidden") return;
      Promise.resolve(refreshRef.current?.()).catch(() => {});
    };

    const timer = intervalMs > 0 ? window.setInterval(run, intervalMs) : null;
    const onVisible = () => {
      if (document.visibilityState === "visible") run();
    };

    if (refreshOnFocus) {
      window.addEventListener("focus", run);
      document.addEventListener("visibilitychange", onVisible);
    }

    return () => {
      if (timer) window.clearInterval(timer);
      window.removeEventListener("focus", run);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [enabled, intervalMs, refreshOnFocus, ...deps]); // eslint-disable-line react-hooks/exhaustive-deps
}
